import { api } from '@services';
import Tag, { ITag, ITagApiModel } from '@models/Tag.model';

interface IMoveTag {
  tagsIds: string[];
  tagCategoryId: string;
}

const moveTags = async (data: IMoveTag): Promise<ITag> => {
  const { data: tag } = await api.post<ITagApiModel>('/tags/move', data);
  return Tag.fromApiModel(tag);
};

export { moveTags };
